/**
 * Get sorted photos
 * @param {array} photos
 * @param {string} param
 * @returns {array}
 */
export default function getSortedPhotos(photos = [], param) {
  const sorted = photos.sort((a, b) => {
    // lastModifiedObj is a dayjs object created when the listing data is normalized
    if (!!a.lastModifiedObj && !!b.lastModifiedObj) {
      if (a.lastModifiedObj.isSame(b.lastModifiedObj)) {
        return 0;
      } else if (param === "oldest") {
        return a.lastModifiedObj.isBefore(b.lastModifiedObj) ? -1 : 1;
      } else {
        return a.lastModifiedObj.isBefore(b.lastModifiedObj) ? 1 : -1;
      }
    }
    // Fallback to available index which is a proxy for upload date
    // neither photo has a date object
    else if (!a.lastModifiedObj && !b.lastModifiedObj) {
      return param === "oldest"
        ? a.availableIndex - b.availableIndex
        : b.availableIndex - a.availableIndex;
    }
    // Otherwise assume the photo without a date object is older
    else if (!a.lastModifiedObj) {
      return param === "oldest" ? -1 : 1;
    } else if (!b.lastModifiedObj) {
      return param === "oldest" ? 1 : -1;
    } else {
      return 0;
    }
  });

  // Create a new array so paged effect will fire
  return [...sorted];
}
